import { render, staticRenderFns } from "./PaymentMag.vue?vue&type=template&id=5b1ab71a&"
import script from "./PaymentMag.vue?vue&type=script&lang=js&"
export * from "./PaymentMag.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports